import React, { Component } from "react";
import { Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import "./login.scss"
import moment from 'moment'
var md5 = require('md5');


class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    	usuario: '',
    	pass: '',
      sessions: [],
      sucursalSelected: '',
      usuarioSelected: '',
    }
  }

  componentDidMount() {
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp?opt=getPreLoginUsers", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({}),
    })
    .then(response => response.json())
    .then((response) => {
      //Si se logra exitosamente reiniciamos la app para volver a validar.
      if(response.length > 0) {
        localStorage.setItem('ws_hgapp_sessions', JSON.stringify(response))
        this.setState({
          sessions: response,
        })
      }
    })
    .catch((err) => {
      if(typeof localStorage.ws_hgapp_sessions === 'string') {
        alert('Sistema sin conexión, puedes iniciar sesión sin conexión. #1')
        const sessions = JSON.parse(localStorage.getItem('ws_hgapp_sessions'))
        this.setState({
          sessions,
        })
      } else {
        alert('Sistema sin conexión, lo sentimos, es obligatorio que te conectes a internet. #2')
      }
    })
  }

  login(e) {
  	const { usuario, pass } = this.state

  	if (pass === '' || usuario === '') {
  		alert('Por favor ingresa un usuario y contraseña.')
  		return false
  	}

  	fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp?opt=login", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...this.state}),
    })
    .then(response => response.json())
    .then((response) => {
    	if ((response) && response.auth) {
    		//Si se logra exitosamente reiniciamos la app para volver a validar.
    		if(response.status === 1) {
	     		localStorage.setItem('hg_app_s', JSON.stringify(response));
	     		this.props.initsetState({ viewApp: '__redirector', })
	     		this.props.history.push('/')
	     		window.location.reload()
    		} else {
    			alert('Tu cuenta se encuentra suspendida. Contacta a tu administrador.')
    		}
    	} else {
    		alert('Credenciales incorrectas.')
    	}
    })
    .catch((err) => {
      alert('Sistema sin conexión #2')
    })

  }

  loginSelected(e) {
    const { sessions, pass, usuarioSelected, } = this.state
    const usuarioFilter = [...new Set(sessions.filter(item => item.usuario === usuarioSelected))][0];

    if (usuarioFilter.password !== md5(pass)) {
      alert(`Por favor ingresa la contraseña correctamente del usuario ${usuarioFilter.usuario}.`)
      return false
    }
    usuarioFilter.auth = 1
    usuarioFilter.last_login = moment().format('YYYY-MM-DD HH:mm:ss')

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp?opt=updateLastAccessUser", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ usuario: usuarioFilter.usuario }),
    })
    .then(response => response.json())
    .then((response) => {
      localStorage.setItem('hg_app_s', JSON.stringify(usuarioFilter));
      this.props.initsetState({ viewApp: '__redirector', })
      this.props.history.push('/')
      window.location.reload()
    })
    .catch((err) => {
      localStorage.setItem('hg_app_s', JSON.stringify(usuarioFilter));
      this.props.initsetState({ viewApp: '__redirector', })
      this.props.history.push('/')
      window.location.reload()
    })

  }

  render() {
    const { sessions, sucursalSelected, usuarioSelected, } = this.state
    const sucursales = [...new Set(sessions.map(item => item.sucursal))];
    const usuarios = [...new Set(sessions.filter(item => item.sucursal === sucursalSelected))];
    const usuarioFilter = [...new Set(sessions.filter(item => item.usuario === usuarioSelected))];

  	return (
      <Container className="loginPage__container" >
        <Row className={'loginPage__formSub'}>
          <div className="col-md-12">
          	<img alt={"img"} src={ 'img/hgapp/logohg-transparent.png' } className={'loginPage__logo'} />
            {
              sessions.length > 0 ? (

                <div className="my-4 loginPage__form" style={{ display: 'block', }}>
                  <div className="row" style={{ display: 'block', }}>
                  {
                    sucursalSelected === '' ? (
                      <>
                      <h3 style={{ textAlign: 'center', }}>Carnicerías Hermanos González</h3>
                      <p className={'loginPage__indicadores'}>¿En qué sucursal estás?</p>
                      {
                        sucursales.map((t,e) => (

                          <div className={'loginPage__lista_items'} onClick={ () => {
                            this.setState({
                              sucursalSelected: t
                            })
                          } }>

                            <p>{t}</p>

                          </div>


                        ))
                      }
                      </>
                    ) : (
                      <>

                      {
                        usuarioSelected === '' ?
                        <>
                        <h3 style={{ textAlign: 'center', }}>Carnicerías Hermanos González</h3>
                        <p className={'loginPage__indicadores'}>Iniciar sesión en {sucursalSelected}</p>
                        <p style={{ cursor: 'pointer', }} onClick={ () => { this.setState({ usuarioSelected: '', sucursalSelected: '', }) } }>Regresar</p>
                        {
                          usuarios.map((t,e) => (

                            <div className={'loginPage__lista_items'} onClick={ () => {
                              this.setState({
                                usuarioSelected: t.usuario
                              })
                            } }>

                              <p>{t.nombre} {t.apellidos}</p>
                              { t.last_login !== '2023-07-20 18:00:32' && <p>Último acceso: {moment(t.last_login).format('DD/MM HH:mm')}</p> }

                            </div>


                          ))
                        }
                        </> : 
                        <>
                        <h3 style={{ textAlign: 'center', }}>Carnicerías Hermanos González</h3>
                        <p className={'loginPage__indicadores'}>Inicia sesión con la cuenta <b>{usuarioSelected}</b></p>
                        <p style={{ cursor: 'pointer', }} onClick={ () => { this.setState({ usuarioSelected: '', }) } }>Regresar</p>
                        
                        <div>
                          <div className="row">
                            <div className="form-group col-md-12 ">
                              <input type="password" className="form-control form-control-lg" placeholder="Ingresa tu contraseña" value={this.state.pass} onChange={(event) => this.setState({pass: event.target.value})} />
                            </div>
                            <div className="form-group col-md-12 ">
                              <input onClick={() => this.loginSelected()} type="button" className="btn btn-lg btn-info btn-block" value="INICIAR SESIÓN" />
                            </div>
                          </div>
                        </div>
                        </>
                      }

                      </>
                    )
                  }
                  </div>

                </div>

              ) : (

                <form className="my-4 loginPage__form">
                  <div className="row">
                    <div className="form-group col-md-12 ">
                      <input type="text" className="form-control form-control-lg" placeholder="Ingresa tu usuario" value={this.state.usuario} onChange={(event) => this.setState({usuario: event.target.value})} />
                    </div>
                    <div className="form-group col-md-12 ">
                      <input type="password" className="form-control form-control-lg" placeholder="Ingresa tu contraseña" value={this.state.pass} onChange={(event) => this.setState({pass: event.target.value})} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-12 ">
                      <input onClick={() => this.login()} type="button" className="btn btn-lg btn-info btn-block" value="INICIAR SESIÓN" />
                    </div>
                  </div>
                </form>


              )
            }
          </div>
      	</Row>
      </Container>
  	);

  }
};

export default withRouter(LoginPage)